// src/modules/competition/components/CompetitionDetails/index.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useAuth } from '../../../../shared/hooks/useAuth';
import { parseLocalDate } from '../../../../shared/utils/dateUtils';

const CompetitionDetails = ({
    currentPeriod,
    pointTarget,
    isUserJoined,
    onJoinClick,
    onJoinTeamClick,
    onManageMembersClick,
    competitionId,
    competitionName,
    isTeamBased,
}) => {
    const { hasPermission } = useAuth();
    const canEdit = hasPermission('competition:edit');
    const canManageTeams = hasPermission('teams:manage');

    const startDate = format(parseLocalDate(currentPeriod.startDate), 'MMM d, yyyy HH:mm');
    const endDate = format(parseLocalDate(currentPeriod.endDate), 'MMM d, yyyy HH:mm');

    return (
        <Card className="mb-3">
            <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
                <span>
                    {competitionName}
                    {isTeamBased && (
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            marginLeft: '10px',
                            fontSize: '0.72rem',
                            fontWeight: 600,
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            color: 'var(--bs-primary)',
                            border: '1.5px solid var(--bs-primary)',
                            borderRadius: '20px',
                            padding: '2px 10px',
                            verticalAlign: 'middle',
                            opacity: 0.85,
                        }}>
                            <i className="bi bi-people-fill"></i>Teams
                        </span>
                    )}
                </span>
                <div>
                    <Link
                        to={`/competition/${competitionId}/stats`}
                        className="btn btn-outline-primary me-2"
                    >
                        View Statistics
                    </Link>
                    {canEdit && (
                        <Link
                            to={`/competition/${competitionId}/edit`}
                            className="btn btn-outline-primary me-2"
                        >
                            <i className="bi bi-pencil me-1"></i>Edit
                        </Link>
                    )}
                    {isTeamBased && canManageTeams && (
                        <Button
                            variant="outline-secondary"
                            className="me-2"
                            onClick={onManageMembersClick}
                        >
                            <i className="bi bi-people me-1"></i>Manage Members
                        </Button>
                    )}
                    {!isUserJoined && (
                        <Button
                            variant="primary"
                            onClick={isTeamBased ? onJoinTeamClick : onJoinClick}
                        >
                            {isTeamBased ? (
                                <><i className="bi bi-people me-1"></i>Join a Team</>
                            ) : (
                                'Join Competition'
                            )}
                        </Button>
                    )}
                </div>
            </Card.Header>
            <Card.Body>
                <Card.Text>
                    Current Period: {startDate} - {endDate}
                </Card.Text>
                <Card.Text>
                    Cake Threshold for Current Period: {pointTarget.toFixed(2)}
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

CompetitionDetails.propTypes = {
    currentPeriod: PropTypes.shape({
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired,
    }).isRequired,
    pointTarget: PropTypes.number.isRequired,
    isUserJoined: PropTypes.bool.isRequired,
    onJoinClick: PropTypes.func.isRequired,
    onJoinTeamClick: PropTypes.func.isRequired,
    onManageMembersClick: PropTypes.func.isRequired,
    competitionId: PropTypes.string.isRequired,
    competitionName: PropTypes.string.isRequired,
    isTeamBased: PropTypes.bool,
};

export default CompetitionDetails;
